import { useMemo, useEffect } from "react";
import { trpc } from 'utils/trpc';
import styled from "styled-components";

import theme, {bp, color} from 'settings/theme';


type Props = {
  isOpen: boolean,
  setIsOpen: (val: boolean) => void,
  sizeChartId?: number | null
};

const SizeChartModal: React.FC<Props> = (props) => {
  
  // Load Size Chart
  const sizeChartQuery = trpc.sizeCharts.getById.useQuery({id: props.sizeChartId ?? 0}, { enabled: !!props.sizeChartId });
  const sizeChart = sizeChartQuery.data;

  console.log("sizeChart", sizeChart);

  // Create chart
  const chart = useMemo(() => {

    if(!sizeChart || !sizeChart.data){
      return {
        columns: [],
        rows: []
      };
    }

    const splitData: string[] = sizeChart.data.split(/\r?\n/);
    const columns = [...splitData[0]?.split(',').map(x => x.trim()) ?? []];

    let rows: string[][] = [];

    if(splitData.length > 1){
      const splitRows = splitData.slice(1);
      rows = splitRows.map(item => item.split(',').map(x => x.trim()));
    }

    return {
      columns,
      rows
    };

  }, [sizeChart]);

  const handleClose = () => {
    props.setIsOpen(!props.isOpen);
  }

  return (
    <StyledSizeChartModal className="sizeChartModal">
      
      <div className="sizeChartModal-topSection">
        <div className="sizeChartModal-title">
          Size Chart
        </div>
        <div className="sizeChartModal-closeButton">
          <button onClick={handleClose}>X</button>
        </div>
      </div>

      <div className="sizeChartModal-chart">
        <table>
          <thead>
            <tr>
              {chart.columns && chart.columns?.map((item, index) => (
                <th key={index}>{item}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {chart.columns && chart.rows?.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((item, itemIndex) => (
                  <td key={itemIndex}>
                    {item}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </StyledSizeChartModal>
  );

};

export default SizeChartModal;



const StyledSizeChartModal = styled.div<{}>`

  padding: 1rem;

  .sizeChartModal-topSection{

    display: flex;
    align-items: center;
    margin-bottom: 1rem;

    .sizeChartModal-title{
      flex: 1;
      font-size: 1.125rem;
      font-weight: 600;
    }

    .sizeChartModal-closeButton{

      flex: 0 0 auto;

      button{

        display: flex;
        align-items: center;
        justify-content: center;
        width: 2rem;
        height: 2rem;
        border-radius: 0.25rem;
        background-color: ${color.gray(25)};
        transition: background-color 0.15s ease-in-out;

        &:hover{
          background-color: ${color.gray(35)};
        }

      }

    }
  }

  .sizeChartModal-chart{

    width: 100%;
    overflow: auto;

    table{

      min-width: 100%;

      thead{
        tr{
          th{
            padding: 0.5rem;
            color: white;
            text-align: left;
            font-size: 0.875rem;
            background-color: ${color.green(35)};
          }
        }
      }
      tbody{
        tr{

          td{

            padding: 0.75rem;
            text-align: left;
            font-size: 0.875rem;
            font-weight: 400;
            background-color: ${color.gray(15)};

            &:first-child{
              font-weight: 600;
            }

          }

          &:nth-child(odd) td{
            background-color: ${color.gray(20)};
          }

        }
      }
    }
    
  }


  @media (min-width: ${bp(3)}) {

  }

`

